/* eslint-disable */
import React, { useState } from 'react';
import { Form, Button, Alert, Card, Spinner } from 'react-bootstrap';
import { useAuth } from 'context/AuthWizardContext';
import { FaTicketAlt, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';

const CloudSolutions = () => {
  const { user } = useAuth();
  const [ticketDesc, setTicketDesc] = useState('');
  const [priority, setPriority] = useState('2'); // Varsayılan öncelik
  const [createdTicketId, setCreatedTicketId] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState(null); // Files state

  const handleCreateTicket = async (e) => {
    e.preventDefault();
    setLoading(true); // Yükleniyor durumu başlasın

    // Create a new FormData object
    const formData = new FormData();
    formData.append('token', user?.token);
    formData.append('process', '100019314');
    formData.append('TICID', null);
    formData.append('CUSID', user?.customer_id);
    formData.append('MEMID', null);
    formData.append('TDESC', ticketDesc);
    formData.append('PRIOR', priority);
    formData.append('LOEKZ', null);
    formData.append('TSTAT', '1');
    formData.append('LODAT', null);
    formData.append('ANDAT', null);

    // Append each file to the formData
    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append('files[]', files[i]);
      }
    }

    try {
      const response = await fetch('https://musteri.guardnet.com.tr/call.php', {
        method: 'POST',
        body: formData, // FormData automatically sets the correct headers
      });

      const data = await response.json();
      if (response.ok && data.TICID) {
        setCreatedTicketId(data.TICID);
        setError(null);
      } else {
        throw new Error('Ticket oluşturulamadı');
      }
    } catch (err) {
      setError(err.message);
      setCreatedTicketId(null);
    } finally {
      setLoading(false); // Yükleniyor durumu bitsin
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh', backgroundColor: '#f8f9fa' }}>
      <Card style={{ width: '100%', maxWidth: '600px', padding: '20px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <Card.Body>
          <div className="text-center mb-4">
            <FaTicketAlt size={40} color="#007bff" />
            <h3 className="mt-2">Yeni Ticket Oluştur</h3>
          </div>
          <Form onSubmit={handleCreateTicket}>
            <Form.Group controlId="formTicketDesc" className="mb-3">
              <Form.Label>Ticket Açıklaması</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Açıklama giriniz"
                value={ticketDesc}
                onChange={(e) => setTicketDesc(e.target.value)}
                required
                style={{ borderRadius: '10px', border: '1px solid #ced4da' }}
              />
            </Form.Group>

            <Form.Group controlId="formPriority" className="mb-4">
              <Form.Label>Öncelik</Form.Label>
              <Form.Select
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
                style={{ borderRadius: '10px', border: '1px solid #ced4da' }}
              >
                <option value="1">Yüksek</option>
                <option value="2">Orta</option>
                <option value="3">Düşük</option>
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="formFileUpload" className="mb-4">
              <Form.Label>Dosya Yükle</Form.Label>
              <Form.Control
                type="file"
                multiple
                onChange={(e) => setFiles(e.target.files)}
                style={{ borderRadius: '10px', border: '1px solid #ced4da' }}
              />
              <Form.Text className="text-muted">
                PDF, video, png, vs. dosyalar desteklenmektedir.
              </Form.Text>
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100"
              style={{ borderRadius: '10px', padding: '10px' }}
              disabled={loading}
            >
              {loading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                'Ticket Oluştur'
              )}
            </Button>
          </Form>

          {createdTicketId && (
            <Alert variant="success" className="mt-4 d-flex align-items-center" style={{ borderRadius: '10px' }}>
              <FaCheckCircle className="me-2" />
              Ticket başarıyla oluşturuldu! Ticket ID: {createdTicketId}
            </Alert>
          )}

          {error && (
            <Alert variant="danger" className="mt-4 d-flex align-items-center" style={{ borderRadius: '10px' }}>
              <FaExclamationCircle className="me-2" />
              Hata: {error}
            </Alert>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default CloudSolutions;
